import styles from './TestimonialModule.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import noop from 'lodash/noop';
import React from 'react';

import {
  CarouselType,
  TestimonialAssembly,
  TextAlignment
} from 'src/api/contentful/contentTypes.cloverdotcom';
import { useResponsive } from 'src/components/Responsive/Responsive';
import { useMediaHover } from 'src/components/Testimonial/Media/UseMediaHover';
import { TextSection } from 'src/components/Testimonial/Text/TextSection';
import { componentKey, getField, isEntry } from 'src/utils/EntryUtil';
import { CarouselModule } from '../CarouselModule/CarouselModule';
import { MediaWrapper } from './Media/MediaWrapper';

interface TestimonialModuleProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<TestimonialAssembly>;
}

export const TestimonialModule: React.FC<TestimonialModuleProps> = ({ entry, className, ...props }) => {

  const { handleMouseEnter, handleMouseLeave, enhancedMediaRef } = useMediaHover();

  const { browser } = useResponsive();

  if (!isEntry(entry)) return null;

  const {
    testimony,
    mediaTopic,
    items,
    textBoxAlignment = TextAlignment.RIGHT,
  } = entry.fields;

  if (!isEntry(testimony)) return null;
  /* ---- Below logic explaind ----
    This component receives either a MediaTopic which is a video, or
    a collection of Images which come in as Items.

    - Only a MediaTopic OR Items can be received, otherwise return null
    - If Items are received, a maximum of 4 can be used, otherwise return null

    - If we receive Items, default the count to 1 for styling purposes
    - If we have more Items than 1 AND the view is mobile, we want to use the CarouselModule
  */
  const mediaTopicAndItems = mediaTopic && items && items.length > 0;

  const imageCount = items && items.length > 0 ? items.length : 1;

  if (mediaTopicAndItems || imageCount > 4) return null;

  const modalLink = getField(mediaTopic, 'link');

  const isMobile = browser.lessThan.tablet;

  const isMobileOrTablet = browser.lessThan.desktop;

  const isMobileWithImages = isMobile && imageCount > 1;

  const isDesktop = browser.is.desktop && !browser.greaterThan.desktop;

  return (
    <section className={cx(className, styles.testimonialModuleWrapper)} {...props}>
      <div className={cx(styles.container, { [styles.containerTextOnLeft]: textBoxAlignment === TextAlignment.LEFT })}>
        <div className={cx(styles.imageWrapper, { [styles.imageWrapperWithHero]: getField(entry, 'carouselType') === CarouselType.HERO })}>
          {mediaTopic && (
            <MediaWrapper
              entry={mediaTopic}
              link={modalLink}
              handleMouseEnter={!isMobileOrTablet ? handleMouseEnter : noop}
              handleMouseLeave={!isMobileOrTablet ? handleMouseLeave : noop}
              enhancedMediaRef={enhancedMediaRef}
              imageCount={imageCount}
            />
          )
         }
         {items && (isMobileWithImages ? (
            <CarouselModule
              entry={entry}
              isMobile={isMobile}
              isDesktop={isDesktop}
            />
          )
         :
         items.map((item, index) => (
            <MediaWrapper
              entry={item}
              link={modalLink}
              enhancedMediaRef={enhancedMediaRef}
              imageCount={imageCount}
              key={componentKey(item, index)}
            />
          ))
         )
        }
        </div>
      <TextSection
        entry={entry}
        withCarousel={isMobileWithImages}
      />
      </div>
    </section>
  );
};
